import _ from "underscore";

export function renderIntegrationStep(app, view, templateOptions) {
  if (templateOptions === undefined) {
    templateOptions = {};
  }

  view.$el.html(view.template(_.extend(templateOptions, app.config.urlConfig)));
  view.stickit();
  return view;
}
